import { Flex, FlexProps } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import logo from '../assets/logos/seagull/seagull-colored.png';

type CenterLogoLayoutProps = FlexProps & {
  logoSrc?: string;
  logoWidth?: string;
  animationClassName?: string;
};

export const CenterLogoLayout = ({
  children,
  logoSrc = logo,
  logoWidth = '100px',
  animationClassName,
  ...wrapperProps
}: PropsWithChildren<CenterLogoLayoutProps>) => (
  <Flex
    className={animationClassName}
    width="100%"
    height="100%"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    gap={4}
    {...wrapperProps}
  >
    <img alt="logo" src={logoSrc} width={logoWidth} />
    {children}
  </Flex>
);
